/* eslint-disable no-shadow */
export enum viewTypeEnum {
  tileView = 'tile',
  listView = 'list',
  mapView = 'map',
  foldersView = 'folders'
}

export enum tokenCustomClaimsEnum {
  userId = 'http://cardinalscales.com/userid'
}

export enum tokenUserIdEnum {
  notFound = 0,
  unauthorized = -1
}

export enum globalSearchEnum {
  locations = 'Locations',
  devices = 'Devices',
  users = 'Users',
  ssid = 'SSID'
}

export enum homeListTypes {
  location = 'Location',
  businessAccount = 'BusinessAccount',
  organization = 'Organization'
}

export const GlobalSearchTypes = [
  globalSearchEnum.locations,
  globalSearchEnum.devices,
  globalSearchEnum.users
  // globalSearchEnum.ssid enable this when the feature is ready and want to show it in the search
];

export enum severityEnum {
  low = 1,
  medium = 2,
  high = 3
}

export enum shareLocationWithTargetsEnum {
  email = 1,
  businessAccount,
  domain
}

export enum locationRoleEnum {
  root = 1,
  admin = 2,
  production = 3
}

export enum authorizedEnum {
  authorized = 1,
  unauthorized = 2
}
